import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { Phone } from 'lucide-react';
const flow = ['LLAMADA ENTRANTE', 'VOICE', 'IDENTIFICA', 'ENTIENDE', 'CALIFICA', 'AGENDA', 'CRM', 'SEGUIMIENTO'];
export function Voice() {
  return <section id="voice" className="bg-arena py-[64px] md:py-[96px]" data-id="element-277" data-mp="b6qytrgscd9f">
      <div className="max-w-[1000px] mx-auto px-6 md:px-20" data-id="element-278" data-mp="68fpdhuek4rq">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="bg-carbon rounded-[12px] p-8 md:p-14 pb-9 md:pb-12 text-center" data-id="element-279" data-mp="k99xs0hga5qe">
          <span className="inline-flex items-center gap-1.5 font-body text-[11px] uppercase tracking-[0.15em] text-salvia mb-5" data-id="element-280" data-mp="13y0v5wnmw09y">
            <Phone size={12} data-id="element-281" data-mp="1vmzxxctgzj6d" /> ORIGEN VOICE
          </span>
          <h2 className="font-display text-[28px] md:text-[40px] font-bold text-arena leading-[1.15] max-w-[560px] mx-auto mb-4" data-id="element-282" data-mp="1vokt94nlz65a">
            Tu empresa también puede contestar el teléfono.
          </h2>
          <p className="font-body text-[16px] md:text-[18px] text-arena/60 leading-[1.6] max-w-[500px] mx-auto mb-10" data-id="element-283" data-mp="24md867pf4bs5">
            Un agente de voz con IA que atiende, entiende, califica, agenda,
            registra y deriva cuando hace falta.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-1.5 mb-10" data-id="element-284" data-mp="2jk5jennxme0j">
            {flow.map((step, idx) => <Fragment key={step} data-id="element-285" data-mp="2oc7673iq7n4t" data-mpi={idx}>
                <span className="font-body text-[12px] text-arena/75 bg-arena/10 rounded-full px-3.5 py-1.5" data-id="element-286" data-mp="2sd967mkgw37u">
                  {step}
                </span>
                {idx < flow.length - 1 && <span className="text-arena/30 text-[12px]" data-id="element-287" data-mp="32bgb371heuth">→</span>}
              </Fragment>)}
          </div>

          {/* Mini call demonstration — ends in a business action, not just a reply */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.4,
          ease: 'easeOut'
        }} className="bg-arena/5 border border-arena/15 rounded-[12px] p-6 max-w-[440px] mx-auto text-left" data-id="element-288" data-mp="xavqh6gfgdr9">
            <div className="space-y-2.5" data-id="element-289" data-mp="1l1roilbh856y">
              <motion.p initial={{
              opacity: 0,
              y: 6
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.3,
              delay: 0.1
            }} className="font-body text-[13px] text-arena/85" data-id="element-290" data-mp="1gymnkn71obkf">
                <span className="text-arena/40" data-id="element-291" data-mp="kwet34zcz4g">Cliente — </span>
                "Hola, quiero saber si tienen disponibilidad esta semana."
              </motion.p>
              <motion.p initial={{
              opacity: 0,
              y: 6
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.3,
              delay: 0.3
            }} className="font-body text-[13px] text-verde font-medium" data-id="element-292" data-mp="278dm6b16cnq3">
                <span className="text-verde/60" data-id="element-293" data-mp="22glsvsqmw3w9">VOICE — </span>
                "Claro. ¿Qué servicio necesitas?"
              </motion.p>
            </div>

            <div className="h-px bg-arena/10 my-4" data-id="element-294" data-mp="1ojywps6i9hre" />

            <motion.div initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true,
            amount: 0.4
          }} transition={{
            duration: 0.3,
            delay: 0.45
          }} className="mb-3" data-id="element-295" data-mp="1thqq6qmstbxp">
              <span className="font-body text-[10px] uppercase tracking-[0.1em] text-azul" data-id="element-296" data-mp="38xpg0lsjsl95">
                LLAMADA COMPLETADA ✓
              </span>
              <p className="font-body text-[12.5px] text-arena/70 mt-0.5" data-id="element-297" data-mp="3dw0pgvexktqu">
                Servicio: Consulta · Intención: Alta
              </p>
              <p className="font-body text-[12.5px] text-arena/70" data-id="element-298" data-mp="19sz4a8zkcc8z">
                Horario solicitado: Jueves · 15:00
              </p>
            </motion.div>

            <div className="flex flex-col gap-2" data-id="element-299" data-mp="14rrxac58vh3d">
              <motion.div initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.3,
              delay: 0.6
            }} data-id="element-300" data-mp="zv1j5ud02vkl">
                <span className="font-body text-[12.5px] font-medium text-arena/85" data-id="element-301" data-mp="q35fm3s5ad8z">
                  CRM · Lead actualizado ✓
                </span>
              </motion.div>
              <motion.div initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.3,
              delay: 0.75
            }} data-id="element-302" data-mp="h539xaxguwfd">
                <span className="font-body text-[12.5px] font-medium text-arena/85" data-id="element-303" data-mp="786zv0rx628p">
                  AGENDA · Cita registrada ✓
                </span>
              </motion.div>
              <motion.div initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.3,
              delay: 0.9
            }} data-id="element-304" data-mp="1z5wow0poazq">
                <span className="font-body text-[12.5px] font-medium text-arena/70" data-id="element-305" data-mp="3ah2dqottmxzr">
                  SEGUIMIENTO · Confirmación automática ✓
                </span>
              </motion.div>
            </div>
          </motion.div>

          <p className="font-body text-[13px] text-arena/50 max-w-[440px] mx-auto mt-8 leading-[1.6]" data-id="element-306" data-mp="3kdylgsbwbg39">
            VOICE se integra con tu sistema ORIGEN para atender llamadas,
            calificar oportunidades, agendar y ejecutar acciones.
          </p>
        </motion.div>
      </div>
    </section>;
}